import * as React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Container from "@mui/material/Container";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";

const tiers = [
  {
    title: "Membership Perks",
    price: "5",
    description: [
      "Unlimited access to all platform features",
      "Complete access to circle and member management",
      "24/7 Help Center support",
      "Priority email support",
    ],
    buttonText: "Subscribe and get access to all services",
    buttonVariant: "outlined",
  },
];

const Pricing = () => {
  return (
    <Container
      id="pricing"
      sx={{
        // pt: { xs: 4, sm: 12 },
        // pb: { xs: 8, sm: 16 },
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: { xs: 3, sm: 6 },
      }}
    >
      <Box
        sx={{
          width: { sm: "100%", md: "80%" },
          textAlign: { sm: "left", md: "center" },
        }}
      >
        <Typography component="h2" variant="h4" color="text.primary">
          Pricing
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Explore our subscription plan, crafted to meet your needs. Enjoy
          unparalleled access to our platform’s features, ensuring a seamless
          experience that redefines excellence. Join us, and empower your
          financial journey today.
        </Typography>
      </Box>
      <Grid container spacing={3} alignItems="center" justifyContent="center">
        {tiers.map((t) => (
          <Grid
            item
            key={t.title}
            xs={12}
            sm={t.title === "Enterprise" ? 12 : 6}
            md={4}
          >
            <Card
              sx={{
                p: 1,
                display: "flex",
                flexDirection: "column",
                gap: 4,
                border:
                  t.title === "Membership Perks" ? "1px solid" : undefined,
                borderColor:
                  t.title === "Membership Perks" ? "primary.main" : undefined,
                background:
                  t.title === "Membership Perks"
                    ? "linear-gradient(#033363, #021F3B)"
                    : undefined,
              }}
            >
              <CardContent>
                <Box
                  sx={{
                    mb: 1,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    color:
                      t.title === "Membership Perks"
                        ? "primary.contrastText"
                        : "",
                  }}
                >
                  <Typography component="h3" variant="h6">
                    {t.title}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "baseline",
                    color:
                      t.title === "Membership Perks"
                        ? "primary.contrastText"
                        : undefined,
                  }}
                >
                  <Typography component="h3" variant="h2">
                    ${t.price}
                  </Typography>
                  <Typography component="h3" variant="h6">
                    &nbsp; per month
                  </Typography>
                </Box>
                <Divider
                  sx={{
                    my: 2,
                    opacity: 0.2,
                    borderColor: "grey.500",
                  }}
                />
                {t.description.map((line) => (
                  <Box
                    key={line}
                    sx={{
                      py: 1,
                      display: "flex",
                      gap: 1.5,
                      alignItems: "center",
                    }}
                  >
                    <CheckCircleRoundedIcon
                      sx={{
                        width: 20,
                        color:
                          t.title === "Membership Perks"
                            ? "primary.light"
                            : "primary.main",
                      }}
                    />
                    <Typography
                      component="div"
                      variant="subtitle2"
                      sx={{
                        color:
                          t.title === "Membership Perks"
                            ? "primary.contrastText"
                            : undefined,
                      }}
                    >
                      {line}
                    </Typography>
                  </Box>
                ))}
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default Pricing;
